<template>
  <b-dropdown :triggers="['hover']" aria-role="list" position="is-bottom-left">
    <template #trigger>
      <button
        class="button"
        :class="{
          'is-success': t.details.status === 'success',
          'is-danger-light': t.details.status === 'refused',
          'is-light': t.details.status === 'cancelled',
          'is-warning': t.details.status === 'error',
          'is-dark': t.details.status === 'refunded',
          'is-danger': t.details.status === 'chargeback',
          'is-light-green':
            t.details.status === 'billingPending' ||
            t.details.status === 'chargebackPaid'
        }"
        slot="trigger"
        @click.stop
      >
        {{
          t.details.status === "success"
            ? "Sucesso"
            : t.details.status === "refused"
            ? "Recusada"
            : t.details.status === "error"
            ? "Erro"
            : t.details.status === "cancelled"
            ? "Cancelada"
            : t.details.status === "open"
            ? "Aberta"
            : t.details.status === "refunded"
            ? "Estornada"
            : t.details.status === "chargeback"
            ? "Chargeback"
            : t.details.status === "chargebackPaid"
            ? "Chargeback pago"
            : "-"
        }}
      </button>
    </template>

    <b-dropdown-item aria-role="listitem" v-if="paymentMethods.length">
      <p>{{ paymentMethods }}</p>
    </b-dropdown-item>

    <b-dropdown-item
      aria-role="listitem"
      v-if="t.details.paymentMethod === 'money'"
    >
      <p>{{ $t("transactions.money") }}</p>
    </b-dropdown-item>

    <b-dropdown-item aria-role="listitem" v-else>
      <p>
        {{
          t.details.paymentMethod === "ben"
            ? "Ben"
            : t.details.paymentMethod === "aleloAlimentacao"
            ? "Alelo Alimentação"
            : t.details.paymentMethod === "aleloRefeicao"
            ? "Alelo Refeição"
            : t.details.paymentMethod === "sodexoAlimentacao"
            ? "Sodexo Alimentação"
            : t.details.paymentMethod === "sodexoRefeicao"
            ? "Sodexo Refeição"
            : t.details.paymentMethod === "vrAlimentacao"
            ? "VR Alimentação"
            : t.details.paymentMethod === "vrRefeicao"
            ? "VR Refeição"
            : t.details.paymentMethod === "ticketAlimentacao"
            ? "Ticket Alimentação"
            : t.details.paymentMethod === "ticketRefeicao"
            ? "Ticket Refeição"
            : t.details.paymentMethod === "verocardAlimentacao"
            ? "Verocard Alimentação"
            : t.details.paymentMethod === "verocardRefeicao"
            ? "Verocard Refeição"
            : "-"
        }}
        (terminal externo)
      </p>
    </b-dropdown-item>

    <b-dropdown-item
      aria-role="listitem"
      v-if="t.details.format === 'showroom'"
    >
      Showroom
      <br />
      <small>(Não houve cobrança)</small>
    </b-dropdown-item>

    <hr class="separator has-background-primary" />

    <b-dropdown-item aria-role="listitem">
      <b>Carrinho: </b>
      {{ `${payments.currencySymbol}${formatMoney(t.cart.totalValue)}` }}
    </b-dropdown-item>

    <div
      v-if="
        (t.discounts.coupon && t.discounts.coupon.total) ||
          t.discounts.cashbackUsed
      "
    >
      <b-dropdown-item
        aria-role="listitem"
        v-if="t.discounts.coupon && t.discounts.coupon.total"
      >
        <b>(-) Cupom: </b>
        {{
          `${payments.currencySymbol}${formatMoney(t.discounts.coupon.total)}`
        }}
        <br />
        <small>
          {{
            t.discounts.coupon.type === "absolute"
              ? `--> ${t.discounts.coupon.name} ${
                  payments.currencySymbol
                }${formatMoney(t.discounts.coupon.value)}`
              : t.discounts.coupon.type === "percentual"
              ? `--> ${t.discounts.coupon.name} ${t.discounts.coupon.value}%`
              : "?"
          }}
        </small>
      </b-dropdown-item>

      <b-dropdown-item aria-role="listitem" v-if="t.discounts.cashbackUsed">
        <b>(-) Cashback: </b>
        {{
          `${payments.currencySymbol}${formatMoney(t.discounts.cashbackUsed)}`
        }}
      </b-dropdown-item>

      <b-dropdown-item aria-role="listitem">
        <hr class="bill-separator has-background-elegant-black-3" />
      </b-dropdown-item>

      <b-dropdown-item aria-role="listitem">
        <b>Total a pagar: </b>
        {{ `${payments.currencySymbol}${formatMoney(t.details.chargedValue)}` }}
      </b-dropdown-item>
    </div>

    <b-dropdown-item aria-role="listitem" v-if="t.details.prepaid">
      <b>Créditos: </b>
      {{ `${payments.currencySymbol}${formatMoney(t.details.prepaid)}` }}
    </b-dropdown-item>

    <div v-if="t.rewards.cashbackAccumulated.total">
      <b-dropdown-item aria-role="listitem">
        <hr class="bill-separator has-background-elegant-black-3" />
      </b-dropdown-item>

      <b-dropdown-item aria-role="listitem">
        <b>(+) Cashback: </b>
        {{
          `${payments.currencySymbol}${formatMoney(
            t.rewards.cashbackAccumulated.total
          )} (${t.rewards.cashbackAccumulated.percentage}%)`
        }}
      </b-dropdown-item>
    </div>
  </b-dropdown>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../../mixins/common";
import { mask } from "../../../mixins/mask";

export default {
  mixins: [common, mask],

  props: ["t"],

  computed: {
    ...mapGetters(["payments"]),

    paymentMethods() {
      let p = [];
      if (this.t.discounts.coupon) p.push("Cupom");
      if (this.t.discounts.cashbackUsed) p.push("Cashback");
      if (this.t.details.prepaid) p.push("Pré-pago");
      return p.join(" + ");
    }
  }
};
</script>

<style scoped>
.separator {
  height: 1px;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.bill-separator {
  height: 1px;
  margin-top: 0.1rem;
  margin-bottom: 0.1rem;
}
</style>
